/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { UserPreferencesControllerUpdateUserPreferencesMutationRequest, UserPreferencesControllerUpdateUserPreferencesMutationResponse, UserPreferencesControllerUpdateUserPreferencesPathParams, UserPreferencesControllerUpdateUserPreferences400, UserPreferencesControllerUpdateUserPreferences401, UserPreferencesControllerUpdateUserPreferences403, UserPreferencesControllerUpdateUserPreferences404 } from "../../models/userPreferencesController/UserPreferencesControllerUpdateUserPreferences";

function getUserPreferencesControllerUpdateUserPreferencesUrl(id: UserPreferencesControllerUpdateUserPreferencesPathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/user-preferences/${id}` as const }  
  return res
}

/**
 * @description Updates the user's preferences. Auto-creates preferences if they don't exist. Validates team membership if updating currentTeamId.
 * @summary Update user preferences
 * {@link /api/v1/user-preferences/:id}
 */
export async function userPreferencesControllerUpdateUserPreferences(id: UserPreferencesControllerUpdateUserPreferencesPathParams["id"], data?: UserPreferencesControllerUpdateUserPreferencesMutationRequest, config: Partial<RequestConfig<UserPreferencesControllerUpdateUserPreferencesMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<UserPreferencesControllerUpdateUserPreferencesMutationResponse, ResponseErrorConfig<UserPreferencesControllerUpdateUserPreferences400 | UserPreferencesControllerUpdateUserPreferences401 | UserPreferencesControllerUpdateUserPreferences403 | UserPreferencesControllerUpdateUserPreferences404>, UserPreferencesControllerUpdateUserPreferencesMutationRequest>({ method : "PATCH", url : getUserPreferencesControllerUpdateUserPreferencesUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}